<template>
<div id=""></div>
</template>

<script>
export default {
  name: 'MainSeguimientoAudtorias',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
